import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Text, TextType } from 'ui-components/components/text';

import { emptyObject } from 'ui-components/default-props/empty';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import style from './style.module.less';
import messages from './messages';

export const PlanLineItemCost = ({ price = emptyObject, isIncludedInPlan = false, isTrial = false, shouldShowAsterisk = false }) => {
  const { value, code } = price;
  const costClass = value > 0 ? style['plan-info-cost'] : style['no-cost'];

  return (
    <div className={classNames(costClass, { [style.included]: isIncludedInPlan }, { [style.strikethrough]: isTrial && !isIncludedInPlan })}>
      {isIncludedInPlan ? (
        <Text textType={TextType.Paragraph} value={shouldShowAsterisk ? messages.includedWithAsterisk : messages.included} />
      ) : (
        <FormattedCurrencyContainer currencyCode={code} fractionDigits={2} value={value} />
      )}
    </div>
  );
};

PlanLineItemCost.propTypes = {
  price: CurrencyPropType,
  isIncludedInPlan: PropTypes.bool,
  isTrial: PropTypes.bool,
  shouldShowAsterisk: PropTypes.bool,
};
